///<reference path="../../node_modules/@angular/forms/src/model.d.ts"/>
import { AbstractControl, FormControl, FormGroup, ValidatorFn } from '@angular/forms'

export const emailValidator = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: string } => {
        const result = /([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{1,6}(?:\.[a-z]{2})?)\S+/i.test(control.value)
        return result === true ? null : { 'error': 'Wrong email format' }
    }
}
export const validateAllFormFields = (formGroup) => {
    Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field)
        if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: false })
        } else if (control instanceof FormGroup) {
            this.validateAllFormFields(control)
        }
    })
}



// WEBPACK FOOTER //
// ./src/models/customValidators.ts